<div [ngClass]="getContainerClasses()" class="w-full h-full grid place-content-center p-2 cursor-pointer"
     (mouseover)="onHover(true)" (mouseout)="onHover(false)">
  <div *ngIf="!isMatIcon" [ngClass]="getIconClasses()">
  </div>
  <!--  <mat-icon *ngIf="isMatIcon" [ngClass]="getIconClasses()" (mouseover)="onHover(true)" (mouseout)="onHover(false)">-->
  <!--    {{icon}}-->
  <!--  </mat-icon>-->
</div>

<div *ngIf="isTooltipVisible && isHovered || showToolTipOnActive || showToolTipOnInactive" class="relative">
  <div class="absolute -top-8 right-10 bg-white py-2 px-3 rounded-xl font-semibold whitespace-nowrap flex">
    <div *ngIf="isActive || isHovered">{{tooltipText}}</div>
    <div *ngIf="showToolTipOnInactive && !isActive && !isHovered">{{inactiveTooltip}}</div>
  </div>
  <div class="absolute -top-4.5 right-9 w-1 h-2 tk-i-rectangle-right"></div>
</div>

<!-- url(/assets/images/map/i-fullscreen-black.svg) -->